module.exports = __webpack_public_path__ + "assets/svg/UI/back-82fef7.svg";